import { render, staticRenderFns } from "./todayTotalPoint.vue?vue&type=template&id=7a9279ba&"
import script from "./todayTotalPoint.vue?vue&type=script&lang=js&"
export * from "./todayTotalPoint.vue?vue&type=script&lang=js&"
import style0 from "./todayTotalPoint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports